import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { getPath } from '@/router/utils';
import { push, canGoBack, back } from 'redux-first-router';

/**
 * From edit -> referrer
 * From create -> referrer
 * Fresh reload -> referrer
 * Fresh reload & no referrer & has prev page in the stack -> prev page
 * Fresh reload & no referrer -> dashboard
 */
export const useNarrativeBack = () => {
  const { getItem } = useQueryStringParam();
  const referrer = getItem('referrer');
  const company = getItem('company');

  const goBack = () => {
    if (referrer && company) {
      const url = new URL(window.location.href);
      url.pathname = referrer;
      url.searchParams.set('company', company);
      const pathWithQuery = `${url.pathname}${url.search}`;
      push(pathWithQuery);
    } else if (referrer) {
      push(referrer);
    } else if (canGoBack()) {
      back();
    } else {
      push(
        getPath({
          type: ROUTE_DASHBOARD,
          payload: {},
        })
      );
    }
  };

  return {
    goBack,
    referrer,
  };
};
